import { Slot } from '@radix-ui/react-slot';
import { cva, type VariantProps } from 'class-variance-authority';
import { clsx } from 'clsx';
import * as React from 'react';

import { UnstyledButton } from './unstyled-button.component';
import styles from './icon-button.module.scss';

const iconButtonVariants = cva(styles.btn, {
  variants: {
    variant: {
      contained: styles['btn-variant-contained'],
      outlined: styles['btn-variant-outlined'],
      text: styles['btn-variant-text'],
    },
    size: {
      xs: styles['btn-size-xs'],
      sm: styles['btn-size-sm'],
      md: styles['btn-size-md'],
      lg: styles['btn-size-lg'],
    },
  },
});

type IconButtonProps = {
  asChild?: boolean;
} & React.ButtonHTMLAttributes<HTMLButtonElement> &
  VariantProps<typeof iconButtonVariants>;

const IconButton = React.forwardRef<HTMLButtonElement, IconButtonProps>(
  ({ className, variant, size, asChild = false, ...props }, ref) => {
    const Comp = asChild ? Slot : UnstyledButton;

    return (
      <Comp
        className={clsx(iconButtonVariants({ variant, size }), className)}
        ref={ref}
        {...props}
      />
    );
  }
);
IconButton.displayName = 'IconButton';

export { IconButton, iconButtonVariants };
export type { IconButtonProps };
